export default "dist/images/block-accordion-line-colored.4a7ec49.png";